import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '',
      component: () =>
        import ('../pages/form.vue'),
    },
    {
      path: '/result',
      name: '',
      component: () =>
        import ('../pages/result.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js